<template>
  <div id="app">
    <section id="overall-wrapper" :style="{
                         'background-color': appBackgroundColor,
                         'height': appHeight,
                         }">
        <router-view/>
    </section>
  </div>
</template>

<script>

import Session from '@/session/service'
import './utilities/localDate_filter'

export default {
  name: 'App',
  created() {

    if (this.$route && this.$route.query){

      if (this.$route.query['x-access-token']){
        Session.setAccessToken(this.$route.query['x-access-token'])
      }

      if (this.$route.query['x-api-key']){
        Session.setApiKey(this.$route.query['x-api-key'])
      }

    }

    if (this.$route) {
      this.appBackgroundColor = this.$route.query.app_background_color || 'white';
      this.appHeight = this.$route.query.app_background_color ? '100%' : 'auto';
    }
  },
  data() {
    return {
      appBackgroundColor: null,
      appHeight: null
    }
  },
}
</script>

<style>

  html, body, #app{
    height: 100%;
  }

  #overall-wrapper{
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue